import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { CopyToClipboardDirective } from '../../../../../core/directives/copy-to-clipboard.directive';
import { ExpandTextModule } from './../../../../../shared/global/expand-text/expand-text.module';

@Component({
    selector: 'phonebook-row-name',
    imports: [CommonModule, CopyToClipboardDirective, ExpandTextModule],
    template: `
    <div class="tw-p-0 tw-pr-0 tw-text-right tw-w-full">
      <div class="tw-flex-start">
        <app-expand-text [placement]="'left'">
          <span small-text class="text-gray tw-text-base" copyToClipboard>
            {{ phonebookName() }}</span
          >
          <div full-text class="full-text-display tw-w-[250px]">
            {{ phonebookName() }}
          </div>
        </app-expand-text>
      </div>
    </div>
  `
})
export class PhonebookRowNameComponent {
  phonebookName = input<string>();
}
